import Link from 'next/link';

function RecentPosts({ highlights }) {
	return (
		<div className="card box">
			<div className="card-content">
				<p className="title is-4 is-family-code">Recent Posts</p>
				<div className="content">
					{highlights.map(({ sys: { id }, fields: { slug, title } }, index) => (
						<p key={id} className="has-text-weight-semibold is-size-6 is-marginless">
							<Link href={`/blog/${slug}`}>{title}</Link>
						</p>
					))}
				</div>
			</div>
		</div>
	);
}

export default RecentPosts;
